import { Typography } from '@mui/material';

const Footer = () => {
  return (
    <div className='bg-[#111827] text-gray-300 py-10 max-w-7xl mx-auto'>
      <div className='max-w-7xl mx-auto px-6 grid grid-cols-4 md:grid-cols-2 lg:grid-cols-4 gap-8'>
        {/* Logo and Description */}
        <div className='space-y-4'>
          <img
            src='https://noahsark-donate-dev.s3.us-east-1.amazonaws.com/landing/Logo-Noahs-Ark-Market.png'
            alt='Pay My Lawyer Logo'
            className='w-28'
          />
          <Typography variant='body2' className='text-sm leading-relaxed'>
            Pay My Lawyer offers user-friendly, streamlined, secure payment processing tailored for
            law firms. Manage your client inventory, calendar, payment history, and referrals with
            ease. Designed by legal professionals for legal professionals. No subscription fees,
            just simple, transparent transaction pricing.
          </Typography>
          <button className='bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700'>
            Facebook
          </button>
        </div>

        {/* Links */}
        <div style={{ alignItems: 'center', marginTop: '130px' }}>
          <Typography className='text-white text-lg font-semibold mb-4'>Link</Typography>
          <ul className='space-y-2 text-sm'>
            <li className='hover:text-white cursor-pointer'>Home</li>
            <li className='hover:text-white cursor-pointer'>Features</li>
            <li className='hover:text-white cursor-pointer'>Pricing</li>
            <li className='hover:text-white cursor-pointer'>About Us</li>
            <li className='hover:text-white cursor-pointer'>Privacy Policy</li>
          </ul>
        </div>

        {/* Help & Support */}
        <div style={{ alignItems: 'center', marginTop: '130px' }}>
          <Typography className='text-white text-lg font-semibold mb-4'>Help & Support</Typography>
          <ul className='space-y-2 text-sm'>
            <li className='hover:text-white cursor-pointer'>FAQ</li>
            <li className='hover:text-white cursor-pointer'>Contact Us</li>
            <li className='hover:text-white cursor-pointer'>Support</li>
          </ul>
        </div>

        {/* Address */}
        <div style={{ alignItems: 'center', marginTop: '130px' }}>
          <Typography className='text-white text-lg font-semibold mb-4'>Our Address</Typography>
          <ul className='space-y-2 text-sm'>
            <li>
              <span className='font-bold'>Email: </span>ceo@paymylawyer.cc
            </li>
            <li>
              <span className='font-bold'>Phone: </span>956-466-6918
            </li>
            <li>
              <span className='font-bold'>Address: </span>1304 E Adams St. Brownsville, Tx. 78520
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className='mt-8 text-center text-sm text-gray-500'>
        © {new Date().getFullYear()} Pay My Lawyer. All rights reserved.
      </div>
    </div>
  );
};

export default Footer;
